import { IParking } from './types';
import { EParkingType, FOfferType } from '../../../../../JsonQuery';

const PARKING_TYPES: IParking[] = [
  { label: 'Неважно', value: null },
  { label: 'Наземная', value: EParkingType.Ground },
  { label: 'Многоуровневая', value: EParkingType.Multilevel },
  { label: 'Подземная', value: EParkingType.Underground },
  { label: 'На крыше', value: EParkingType.Rooftop },
];

export function getParkingTypes(offerType: FOfferType, isRedesign?: boolean) {
  if (offerType === FOfferType.Garage) {
    return PARKING_TYPES.filter(({ value }) => value !== EParkingType.Rooftop);
  }

  return isRedesign ? PARKING_TYPES.filter(({ value }) => value !== EParkingType.Rooftop) : PARKING_TYPES;
}
